import { render, staticRenderFns } from "./ArcButton.vue?vue&type=template&id=a6c3f3dc&scoped=true"
import script from "./ArcButton.vue?vue&type=script&lang=js"
export * from "./ArcButton.vue?vue&type=script&lang=js"
import style0 from "./ArcButton.vue?vue&type=style&index=0&id=a6c3f3dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c3f3dc",
  null
  
)

export default component.exports